/**
 * This file is part of Mood board.
 *
 * Mood board is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * Mood board is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * Mood board.  If not, see <https://www.gnu.org/licenses/>.
 */

import './style.scss';

{
	const randomNumber = function ( max ) {
		return Math.floor( Math.random() * max );
	}

	document.querySelectorAll( '.wp-block-tandem-mood-board' ).forEach( function ( el ) {
		'use strict';

		let zIndex = 1;
		let draggedElement = null;

		const onDragEnd = function ( event ) {
			if ( ! draggedElement || (event.button !== 0 && !event.targetTouches)) {
				return;
			}
			window.removeEventListener( 'touchcancel', onDragEnd );
			window.removeEventListener( 'touchend', onDragEnd );
			window.removeEventListener( 'touchmove', onDragOver );
			window.removeEventListener( 'mouseup', onDragEnd );
			window.removeEventListener( 'mousemove', onDragOver );
			delete draggedElement.el.dataset.grabbed;
			draggedElement = null;
		};

		const onDragOver = function ( event ) {
			if ( ! draggedElement ) {
				return;
			}
			const reference = event.targetTouches ? event.targetTouches[0] : event;
			draggedElement.el.style.left = ( reference.clientX - draggedElement.offsetX ) + 'px';
			draggedElement.el.style.top = ( reference.clientY - draggedElement.offsetY ) + 'px';
		};

		const onDragStart = function ( event ) {
			if ( draggedElement || (event.button !== 0 && !event.targetTouches) ) {
				return;
			}
			event.preventDefault();
			const child = event.target;
			child.dataset.grabbed = 'true';
			child.style.zIndex = ++zIndex;
			const reference = event.targetTouches ? event.targetTouches[0] : event;
			draggedElement = {
				el: child,
				offsetX: reference.clientX - child.offsetLeft,
				offsetY: reference.clientY - child.offsetTop,
			};
			window.addEventListener( 'mousemove', onDragOver );
			window.addEventListener( 'mouseup', onDragEnd );
			window.addEventListener( 'touchmove', onDragOver );
			window.addEventListener( 'touchend', onDragEnd );
			window.addEventListener( 'touchcancel', onDragEnd );
		};

		el.querySelectorAll( '.wp-block-tandem-mood-board-item' ).forEach( function ( child ) {
			child.style.left = randomNumber( el.clientWidth - child.clientWidth ) + 'px';
			child.style.top = randomNumber( el.clientHeight - child.clientHeight ) + 'px';
			child.style.zIndex = zIndex;
			child.addEventListener( 'mousedown', onDragStart );
			child.addEventListener( 'touchstart', onDragStart );
		} );

		el.classList.add( 'initialized' );
	} );
}
